export const CDN_BASE_URL = 'https://cdn.missionlane.com'

export const AUTHORIZED_AGENT_FORM_URL = `${CDN_BASE_URL}/docs/mission-lane-authorized-agent-designation-rev-03-18-2025.pdf`
export const CONSUMER_PRIVACY_NOTICE_URL = `${CDN_BASE_URL}/docs/mission-lane-consumer-privacy-notice-rev-01-30-2023.pdf`
export const NM_CONSUMER_INFORMATION_BROCHURE_URL = `${CDN_BASE_URL}/docs/nm-consumer-information-brochure.pdf`
export const NM_LICENSE_URL = `${CDN_BASE_URL}/docs/nm-license-2478.pdf`
export const PRIVACY_REQUEST_FORM_URL =
  'https://support.missionlane.com/hc/en-us/requests/new?ticket_form_id=33100870201491'
export const TAB_BANK_PRIVACY_NOTICE_URL = `${CDN_BASE_URL}/docs/tab-bank-privacy-notice-rev-11-2019.pdf`
export const TAB_BANK_PRIVACY_POLICY_URL = 'https://www.tabbank.com/privacy-policy'
export const WEBBANK_PRIVACY_POLICY_URL = `${CDN_BASE_URL}/docs/webbank-privacy-notice-rev-09-2026.pdf`
